import { render, staticRenderFns } from "./Bind.vue?vue&type=template&id=3e47925d&"
import script from "./Bind.vue?vue&type=script&lang=ts&"
export * from "./Bind.vue?vue&type=script&lang=ts&"
import style0 from "./Bind.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports